export default __webpack_public_path__ + "static/media/Portada web memoria.3da9e07f.png";